export const EventManagementDetailsData = [
  {
    icon:"icon-park-outline:video-conference",
    title:'Conference management and organization',
    titleAR:'إدارة وتنظيم المؤتمرات',
    disc:"We handle the full planning and coordination of conferences, ensuring a smooth experience from start to finish.",
    discAR:"نحن نتولى التخطيط الكامل والتنسيق الشامل للمؤتمرات، لنضمن لك تجربة سلسة واحترافية من البداية وحتى النهاية.",
    link:'/Conference-page'
  },
  {
    icon:"ic:sharp-video-settings" ,
    title:'Implementation of conference-related work',
    titleAR:'تنفيذ أعمال المؤتمرات',
    disc:"From logistics to technical execution, we manage all conference details with precision for a flawless delivery.",
    discAR:"من التخطيط العملي والاداره إلى التنفيذ التقني، ندير جميع تفاصيل المؤتمرات بدقة لضمان تجربة مثالية وخالية من الأخطاء.",
    link:'/implementation-page'
  },

]